export const BREAKPOINT_CHANGE = 'layout/BREAKPOINT_CHANGE';



// WEBPACK FOOTER //
// ./src/modules/layout/layout.actionTypes.js